import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-compare-listing',
  templateUrl: './compare-listing.component.html',
  styleUrls: ['./compare-listing.component.css']
})
export class CompareListingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
